module.exports = __webpack_public_path__ + "/img/volume.gif";